import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Flashbar from "@amzn/awsui-components-react/polaris/flashbar";

export default function StatusBar(props) {
    const [items, setItems] = React.useState([]);
    const statusBarMessage = useSelector((state) => state.currentViews.statusBarMessage);

    useEffect(() => {
        if(statusBarMessage) {
            setItems([
                {
                    type: statusBarMessage.type,
                    content: statusBarMessage.message,
                    dismissible: true,
                    dismissLabel: "Dismiss message",
                    onDismiss: () => setItems([]),
                    id: statusBarMessage.id ? statusBarMessage.id : 0
                  }
            ]);
          }
    }, [statusBarMessage])

    return <Flashbar items={items} />;
}